






















































import {
  apiTradeGeneralTradeGetChannelDiscountAmount,
  ApiTradeGeneralTradeGetChannelDiscountAmountResponse,
} from '@/api'
import { defineClassComponent, useMessenger } from '@/hooks'
import { ref } from '@vue/composition-api'
import { submit } from '@/utils'

export default defineClassComponent<{
  value: number
  preOrderData: any
}>(
  {
    props: ['value', 'preOrderData'],
  },
  ({ props, ctx }) =>
    class {
      showPicker = ref(false)

      channelIndex = useMessenger(
        () => props.value,
        v => ctx.$emit('input', v),
      )

      channelRes = ref<ApiTradeGeneralTradeGetChannelDiscountAmountResponse>()

      handleChannelClick = (index: number) => {
        submit(async $ => {
          $.start()
          const res = await apiTradeGeneralTradeGetChannelDiscountAmount({
            preOrderId: props.preOrderData.preOrderId,
            activityId:
              this.channelIndex.value === index
                ? ''
                : props.preOrderData.channelActivityItems[index].id,
          })
          this.channelRes.value = res
          this.channelIndex.value =
            this.channelIndex.value === index ? (null as any) : index
          this.showPicker.value = false
          ctx.$emit('confirm', res)
        })
      }
    },
)
